(function () {
    'use strict';

    angular.module('app.production', ['smart-table', 'treeControl', 'ui.bootstrap', 'ngTable']);
})();